/*
 * @Description: 语言包整合
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

import menu from './menu';
import layout from './layout';
import dashboard from './dashboard';
import leads from './leads';
import custom from './custom';
import customer from './customer';
import opportunity from './opportunity';
import priceSheet from './price-sheet';
import contract from './contract';
import order from './order';
import product from './product';
import roles from './roles';
import calendar from './calendar';
import dataAnalysis from './data-analysis';
import bi from './bi';
import operation from './operation';
import filter from './filter';
import tips from './tips';
import service from './service';
import publics from './public';
import subForm from './sub-form';
import setConnector from './setting/connector';
import setFlowStage from './setting/flow-stage';
import setObject from './setting/object';
import setPlugin from './setting/plugin';
import setRule from './setting/rule';
import setUserList from './setting/user-list';
import setApprove from './setting/approve';
import returnOrder from './return-order';
import setCost from './setting/cost';
import setLeadPool from './setting/lead-pool';
import setImport from './setting/import';
import setInterface from './setting/interface';
import contractPlugin from './setting/contract';
import engine from './setting/engine';
import authority from './setting/object-authority';
import task from './task';
import formDesign from './setting/form-design';
import view from './setting/view';
import settingLayout from './setting/layout';
import aggregation from './aggregation';
import upload from './upload';
import ai from './ai';

export default {
  ...menu,
  ...layout,
  ...settingLayout,
  ...dashboard,
  ...leads,
  ...custom,
  ...customer,
  ...opportunity,
  ...priceSheet,
  ...contract,
  ...order,
  ...product,
  ...calendar,
  ...dataAnalysis,
  ...subForm,
  ...bi,
  ...operation,
  ...filter,
  ...tips,
  ...service,
  ...publics,
  ...setConnector,
  ...setFlowStage,
  ...setObject,
  ...setPlugin,
  ...setRule,
  ...setImport,
  ...setUserList,
  ...roles,
  ...setApprove,
  ...returnOrder,
  ...setCost,
  ...setLeadPool,
  ...setInterface,
  ...contractPlugin,
  ...engine,
  ...authority,
  ...task,
  ...formDesign,
  ...view,
  ...aggregation,
  ...upload,
  ...ai
};
